var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import useUserContext from '~/contexts/user';
import trackLink from '../../track-link';
import './thank-you-form.scss';
import SchoolSelector from '~/components/school-selector/school-selector';
function FormWithAfterSubmit(_a) {
    var { afterSubmit, responseId = 'form-response', children } = _a, formProps = __rest(_a, ["afterSubmit", "responseId", "children"]);
    const iframeRef = React.useRef(null);
    const onSubmit = React.useCallback(() => {
        const iframe = iframeRef.current;
        const runAfterSubmit = () => {
            afterSubmit();
            iframe === null || iframe === void 0 ? void 0 : iframe.removeEventListener('load', runAfterSubmit);
        };
        iframe === null || iframe === void 0 ? void 0 : iframe.addEventListener('load', runAfterSubmit);
    }, [afterSubmit]);
    return (React.createElement(React.Fragment, null,
        React.createElement("iframe", { name: responseId, className: "hidden", src: "", width: "0", height: "0", tabIndex: -1, ref: iframeRef }),
        React.createElement("form", Object.assign({ target: responseId }, formProps, { onSubmit: onSubmit, name: "thank-you form" }), children)));
}
export default function ThankYou({ link, close, source, itemType = 'PDF', track, id }) {
    const { userModel } = useUserContext();
    const first = userModel === null || userModel === void 0 ? void 0 : userModel.first_name;
    const last = userModel === null || userModel === void 0 ? void 0 : userModel.last_name;
    const school = userModel === null || userModel === void 0 ? void 0 : userModel.self_reported_school;
    const afterSubmit = React.useCallback(() => {
        window.open(link);
        close();
    }, [link, close]);
    const trackDownload = React.useCallback((event) => {
        trackLink(event, id);
    }, [id]);
    return (React.createElement(FormWithAfterSubmit, { action: `${process.env.API_ORIGIN}/apps/cms/api/donations/thankyounote/`, method: "post", className: "thank-you-form", afterSubmit: afterSubmit },
        React.createElement("input", { type: "hidden", name: "source", value: source }),
        React.createElement("h1", null, "Send us a thank you note"),
        React.createElement("div", { className: "instructions" },
            React.createElement("span", { className: "asterisk" }),
            "indicates required field"),
        React.createElement("label", null,
            "Your message ",
            React.createElement("span", { className: "asterisk" }),
            React.createElement("textarea", { name: "thank_you_note", rows: 4, placeholder: "Start typing", required: true })),
        React.createElement("div", { className: "names" },
            React.createElement("label", null,
                "First name ",
                React.createElement("span", { className: "asterisk" }),
                React.createElement("input", { name: "first_name", type: "text", placeholder: "Your first name", required: true, defaultValue: first })),
            React.createElement("label", null,
                "Last name ",
                React.createElement("span", { className: "asterisk" }),
                React.createElement("input", { name: "last_name", type: "text", placeholder: "Your last name", required: true, defaultValue: last })),
            React.createElement(SchoolSelector, { initialValue: school }),
            React.createElement("label", null,
                "Email address",
                React.createElement("input", { name: "contact_email_address", type: "email", placeholder: "Your email (optional)" }))),
        React.createElement("div", { className: "consent-checkbox" },
            React.createElement("label", null,
                "Consent ",
                React.createElement("span", { className: "asterisk" })),
            React.createElement("label", { className: "cb-group" },
                React.createElement("input", { type: "checkbox", name: "consent_to_share_or_contact", value: "True" }),
                "By clicking here I understand that OpenStax may include my story in publications and distribution in printed, electronic, and digital media.")),
        React.createElement("button", { className: "primary" },
            "Submit note and go to ",
            itemType),
        React.createElement("a", Object.assign({ className: "never-mind", href: link }, (track ? { 'data-track': track } : {}), { "data-variant": itemType, onClick: trackDownload }),
            "Never mind, just go to the ",
            itemType)));
}
export function useOnThankYouClick() {
    const [showThankYou, setShowThankYou] = React.useState(false);
    const onThankYouClick = React.useCallback((event) => {
        event.preventDefault();
        setShowThankYou(true);
    }, []);
    return { showThankYou, onThankYouClick };
}
